import api from '../../api'
import {orderItems, relevantNotices} from '../../helpers'
import Vue from 'vue';

export default {
    state: {
        themes: [],
        current: null,
        current_task: null,
        current_relevant_notices: null,
        picked_sub: null,
        relevant_element: null,
    },
    mutations:{
        ADD_THEME: (state, theme) => {
            state.themes.push(theme)
        },
        DEL_THEME: (state, _id) => {
            state.themes = state.themes.filter( theme => theme._id != _id)
        },
        RENAME_THEME: (state, {_id, name}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    theme.name = name
                    return true
                }
            }
        },
        SET_HEAD_GROUPS_TASKS: (state, {theme_id, groups}) => {
            for (const theme of state.themes) {
                if(theme._id == theme_id){
                    Vue.set(theme,'groups', groups)
                    return true 
                }
            }
        },
        SET_ITEMS_GROUPS_TASKS: (state, {theme_id, groups}) => {
            for (const theme of state.themes) {
                if(theme._id == theme_id){
                    Vue.set(theme,'groups', groups)
                    return true 
                }
            }
        },
        UPD_THEME: (state, {_id, tasks}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    theme.tasks = tasks
                    return true
                }
            }
        },      
        RENAME_TASK: (state, {_id, task_id, name}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            task.name = name
                            return true
                        }
                    }
                }
            }
        },
        SET_COMPLETED_TASK: (state, {_id, task_id, value}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            Vue.set(task,'completed', value)
                            return true
                        }
                    }
                }
            }
        },
        SET_COMPLETED_RELEVANT_NOTICE: (state, {notice_id, tasksId}) => {
            for (const theme of state.themes) {
                if (theme._id == state.current._id){
                    for (const task of theme.tasks) {
                        if (task._id == state.current_task._id) {
                            for (const notice of state.current_relevant_notices) {
                                if (notice._id == notice_id) {
                                    Vue.set(notice,'completedInTasks', tasksId)
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },
        SET_ELDER_TASK: (state, {_id, task_id, value}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            task.elder = value
                            return true
                        }
                    }
                }
            }
        },
        EDIT_TASK: (state, {_id, task_id, text}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            task.body = text
                            return true
                        }
                    }
                }
            }
        },
        UPD_TASK: (state, {_id, task_id, subs}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            task.subs = subs
                            return true
                        }
                    }
                }
            }
        },
        UPDATE_TASK: (state, {_id, task_id, attr, value}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            task[attr] = value
                            return true
                        }
                    }
                }
            }
        },
        MOVE_TASK: (state, {theme_from_id, theme_to_id, task_id, to_tasks}) => {
            for (const theme of state.themes) {
                if (theme._id == theme_to_id) {
                    theme.tasks = to_tasks
                }
                if(theme._id == theme_from_id) {
                    theme.tasks.splice(theme.tasks.findIndex(item => item._id == task_id), 1) 
                }
            }
        },  
        MOVE_SUB: (state, {theme_from_id, task_from_id, task_to_id, sub_id, to_subs}) => {
            for (const theme of state.themes) {
                if (theme._id == theme_from_id) {
                    for (const task of theme.tasks) {
                        if (task._id == task_to_id) {
                            task.subs = to_subs
                        }
                        if (task._id == task_from_id) {
                            task.subs.splice(task.subs.findIndex(item => item._id == sub_id), 1) 
                        }
                    }
                }
            }
        },    
        RENAME_SUB: (state, {_id, task_id, sub_id, name}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    sub.name = name
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },        
        SET_COMPLETED_SUB: (state, {_id, task_id, sub_id, value}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    Vue.set(sub,'completed', value)
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },        
        SET_ELDER_SUB: (state, {_id, task_id, sub_id, value}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    sub.elder = value
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },        
        EDIT_SUB: (state, {_id, task_id, sub_id, text}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    sub.body = text
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },        
        UPDATE_SUB: (state, {_id, task_id, sub_id, attr, value}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    sub[attr] = value
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },        
        PUT_THEMES: (state, themes) => {
            state.themes = themes
        },
        CLEAR_THEMES: (state) => {
            state.themes = []
        },
        SET_CURRENT: (state, theme) => {
            state.current = theme
        },      
        SET_CURRENT_BY_ROUTE: (state, {theme}) => {
            const themeFiltred = state.themes.filter(el => el.route_name == theme)[0]
            if(!themeFiltred) 
                return false
            return state.current = themeFiltred
        },      
        CLEAR_CURRENT: (state) => {
            state.current = null
        },                 
        SET_CURRENT_TASK: (state, task) => {
            state.current_task = task
        },      
        SET_CURRENT_TASK_BY_ROUTE: (state, {task}) => {
            if(!state.current) return
            const taskFiltred = state.current.tasks.filter(el => el.route_name == task && !el.completed)[0]
            if(!taskFiltred) 
                return false
            state.current_task = taskFiltred
        },      
        CLEAR_CURRENT_TASK: (state) => {
            state.current_task = null
        }, 
        SET_ORDER_TASKS: (state, tasks_id) => {
            state.current.taskOrder = tasks_id
        },               
        SET_CURRENT_RELEVANT_NOTICES: (state, relevantedNotices) => {
            state.current_relevant_notices = relevantedNotices
        },
        SET_PICKED_SUB: (state, sub) => {
            state.picked_sub = sub
        },
        TOGGLE_PICKED_SUB: (state, {sub,relNotices,relNoticesForSub}) => {
            if(state.picked_sub && state.picked_sub._id == sub._id) {
                state.picked_sub = null
                state.current_relevant_notices = relNotices
            } else {
                state.picked_sub = sub
                state.current_relevant_notices = relNoticesForSub
            }
        },           
        SET_RELATED_TASK_IN_TASK: (state, {_id, task_id, relatedTasksId}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            Vue.set(task,'relatedTasks', relatedTasksId)
                            return true
                        }
                    }
                }
            }
        },
        SET_RELATED_SUB_IN_TASK: (state, {_id, task_id, relatedSubsId}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            Vue.set(task,'relatedSubs', relatedSubsId)
                            return true
                        }
                    }
                }
            }
        },
        SET_RELATED_TASK_IN_SUB: (state, {_id, task_id, sub_id, relatedTasksId}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    Vue.set(sub,'relatedTasks', relatedTasksId)
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },
        SET_RELATED_SUB_IN_SUB: (state, {_id, task_id, sub_id, relatedSubsId}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){
                            for (const sub of task.subs) {
                                if(sub._id == sub_id){
                                    Vue.set(sub,'relatedSubs', relatedSubsId)
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },
        SET_ATTACHMENTS_IN_TASK: (state, {_id, task_id, urls}) => {
            for (const theme of state.themes) {
                if(theme._id == _id){
                    for (const task of theme.tasks) {
                        if(task._id == task_id){ 
                            Vue.set(task,'attachments', {images: urls})
                            return true
                        }
                    }
                }
            }
        },
        SET_RELEVANT_ELEMENT: (state, element) => {
            state.relevant_element = element
        },
    },
    actions: {
        async uploadFiles({ commit }, formData){
            try {                
                // let blobs = await Promise.all([...files.map(file => fetch(file).then(r => r.blob()))])
                // const formData = new FormData()
                // blobs.forEach((blob, i) => {
                //     formData.append(i, blob, i + '.' + files[i].split('.')[files[i].split('.').length - 1])
                // })
                const resData = await api.postFormData('/files', formData)
                return resData.data
            } catch (e) {
                commit('SET_ERROR', 'Не удалось загрузить файл')
                throw e
            }
        },
        async addTheme({ commit }, theme) {
            try {
                const req = await api.post('/folders', theme)
                commit('ADD_THEME', req.data.data)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить раздел')
                throw e
            }
        },        
        async delTheme({ commit }, _id) {
            try {
                const req = await api.delete('/folders/' + _id)
                commit('DEL_THEME', _id)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить раздел')
                throw e
            }            
        },        
        async renameTheme({ commit }, {_id, name}) {
            try {
                const req = await api.put('/folders/' + _id, { attr: 'name', value: name })
                commit('RENAME_THEME', {_id, name})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переименовать раздел')
                throw e
            } 
        },        
        async addHeadToGroup({ commit }, {theme, taskId, tasksId}) {
            try {
                if (!theme.groups) {
                    theme.groups = []
                }
                theme.groups.push({_id: theme._id, headId: taskId, itemsId: tasksId})
                const groups = theme.groups
                const req = await api.put('/folders/' + theme._id, { attr: 'groups', valueJson: JSON.stringify(groups)})
                commit('SET_HEAD_GROUPS_TASKS', {theme_id: theme._id, groups})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить головной подраздел в разделе')
                throw e
            } 
        },
        async deleteHeadToGroup({ commit }, {theme, taskId}) {
            try {
                theme.groups.splice(theme.groups.map(el => el.headId).indexOf(taskId), 1)
                const groups = theme.groups
                const req = await api.put('/folders/' + theme._id, { attr: 'groups', valueJson: JSON.stringify(groups)})
                commit('SET_HEAD_GROUPS_TASKS', {theme_id: theme._id, groups})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить головной подраздел в разделе')
                throw e
            } 
        },
        async addItemsToGroup({ commit }, {theme, taskId, task_id}) {
            try {
                const headTasks = theme.groups.find(el => el.headId == taskId)
                headTasks.itemsId.push(task_id)
                const groups = theme.groups
                const req = await api.put('/folders/' + theme._id, { attr: 'groups', valueJson: JSON.stringify(groups)})
                commit('SET_ITEMS_GROUPS_TASKS', {theme_id: theme._id, groups})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить группу подразделов в разделе')
                throw e
            } 
        },
        async deleteItemsToGroup({ commit }, {theme, taskId, task_id}) {
            try {
                const headTasks = theme.groups.find(el => el.headId == taskId)
                headTasks.itemsId.splice(headTasks.itemsId.indexOf(task_id), 1)
                const groups = theme.groups
                const req = await api.put('/folders/' + theme._id, { attr: 'groups', valueJson: JSON.stringify(groups)})
                commit('SET_ITEMS_GROUPS_TASKS', {theme_id: theme._id, groups})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить группу подразделов в разделе')
                throw e
            } 
        },
        updateTheme({ commit }, {_id, tasks}) {
            // /themes
            commit('UPD_THEME', {_id, tasks})
        }, 
        async saveOrderThemes({ commit }, themes_id) {
            try {
                const req = await api.put('/user', {attr: 'themesOrder', valueJson: JSON.stringify(themes_id)})
                commit('SET_ORDER_THEMES', themes_id)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось сохранить порядок разделов')
                throw e
            }
        },
        async setLearned({ commit }) {
            try {
                const req = await api.put('/user', {attr: 'learned', value: true})
                commit('SET_LEARNED')
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось пройти обучение')
                throw e
            }
        }, 
        async saveOrderTasks({ commit }, {_id, tasks_id}) {
            try {
                const req = await api.put(`/folders/${_id}`, {attr: 'taskOrder', valueJson: JSON.stringify(tasks_id)});
                commit('SET_ORDER_TASKS', tasks_id)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось сохранить порядок подразделов')
                throw e
            }
        },       
        async getThemes({ commit, state, getters, dispatch}, params) {
            try {
                let req
                req = await api.get('/folders')
                req.data.data.forEach(theme => {
                    theme.tasks.forEach(task => {
                        task.parent_name = `${theme.name}`
                        task.parent_route = `/theme/${theme.route_name}`
                        task.subs.forEach(sub => {
                            sub.parent_name = `${theme.name} - ${task.name}`
                            sub.parent_route = `/theme/${theme.route_name}/${task.route_name}`
                        })
                    })
                })
                const themeDrags = orderItems(req.data.data, getters.orderThemes)
                const taskDrags = [] 
                themeDrags.forEach(theme => {
                    theme.tasks = orderItems(theme.tasks,theme.taskOrder)
                    taskDrags.push(theme)
                }) 
                if (getters.orderThemes.length) {
                    commit('PUT_THEMES',taskDrags)
                } else {
                    commit('PUT_THEMES', req.data.data)
                }
                if (params.theme) {
                    commit("SET_CURRENT_BY_ROUTE", params)
                    if (params.task) {
                        await dispatch('setRelavantNoticesByRoute', params)
                    } else {
                        await dispatch('setRelavantNotices', state.current.tasks.filter(el => !el.completed)[0]) 
                    }
                }else{
                    state.themes.length && commit('SET_CURRENT', state.themes[0]) 
                    state.themes[0] && state.themes[0].tasks.filter(el => !el.completed).length && await dispatch('setRelavantNotices', state.themes[0].tasks.filter(el => !el.completed)[0])                      
                }                                                 
                return true;
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось получить разделы')
                throw e;
            }
        }, 
        setRelavantNotices({ commit, getters }, task) {
            try {
                commit('SET_CURRENT_TASK', task)
                getters.current_task && commit('SET_CURRENT_RELEVANT_NOTICES', relevantNotices(getters.feeds, getters.current_task))                                     
                return true;
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось получить релевантные заметки')
                throw e;
            }
        },
        setRelavantNoticesByRoute({ commit, getters }, params) {
            try {
                commit("SET_CURRENT_TASK_BY_ROUTE", params)
                getters.current_task && commit('SET_CURRENT_RELEVANT_NOTICES', relevantNotices(getters.feeds, getters.current_task))                                  
                return true;
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось получить релевантные заметки с роутинга')
                throw e;
            }
        },
        async addTask({ commit }, {theme_id, task}) {
            try {
                const req = await api.post(`/folders/${theme_id}/tasks`, task)
                commit('UPD_THEME',{_id:theme_id, tasks: req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить подраздел')
                throw e
            }
        },  
        async renameTask({ commit }, {_id, task_id, name}) {
            try {
                const req = await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'name', value: name })
                commit('RENAME_TASK', {_id, task_id, name})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переименовать подраздел')
                throw e
            } 
        },              
        async setCompletedTask({ commit }, {_id, task_id, value}) {
            try {
                await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'completed', value })
                commit('SET_COMPLETED_TASK', {_id, task_id, value})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить подраздел в архив')
                throw e
            } 
        },              
        async setElderTask({ commit }, {_id, task_id, value}) {
            try {
                await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'elder', value })
                commit('SET_ELDER_TASK', {_id, task_id, value})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Failed to elder task')
                throw e
            } 
        },              
        async editTask({ commit }, {_id, task_id, text}) {
            try {
                const req = await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'body', value: text })
                commit('EDIT_TASK', {_id, task_id, text})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось отредактировать подраздел')
                throw e
            } 
        },
        async setImagesToTask({ commit }, {_id, task_id, images}) {
            try {
                const req = await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'images', valueJson: JSON.stringify(images) })
                commit('UPDATE_TASK', {_id, task_id, attr: 'images', value: images})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить картинку для подраздела')
                throw e
            } 
        },
        async setBlockedLinksToTask({ commit }, {_id, task_id, blockedLinks}) {
            try {
                const req = await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'blockedLinks', valueJson: JSON.stringify(blockedLinks) })
                commit('UPDATE_TASK', {_id, task_id, attr: 'blockedLinks', value: blockedLinks})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить картинку для подраздела в черный список')
                throw e
            } 
        }, 
        async moveTask({ commit }, {theme_from_id, task_id, theme_to_id, to_tasks}) {
            try {
                const req = await api.put(`/folders/${theme_from_id}/tasks/${task_id}/move/${theme_to_id}`, {})
                commit('MOVE_TASK', {theme_to_id, theme_from_id, task_id, to_tasks: req.data.data}) 
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переместить подраздел')
                throw e
            }
        },          
        async delTask({ commit }, {theme_id, task_id}) {
            try {
                const req = await api.delete(`/folders/${theme_id}/tasks/${task_id}`)
                commit('UPD_THEME',{_id:theme_id, tasks: req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить подраздел')
                throw e
            }
        },
        async addSub({ commit }, {theme_id, task_id, sub}) {
            try {
                const req = await api.post(`/folders/${theme_id}/${task_id}/subs`, sub)
                const subs = req.data.data
                commit('UPD_TASK',{_id:theme_id, task_id, subs})
                return subs[subs.length - 1]
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить заметку')
                throw e
            }
        },     
        async renameSub({ commit }, {_id, task_id, sub_id, name}) {
            try {
                await api.put(`/folders/${_id}/${task_id}/subs/${sub_id}`, { attr: 'name', value: name })
                commit('RENAME_SUB', {_id, task_id, sub_id, name})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переименовать заметку')
                throw e
            } 
        },          
        async setCompletedSub({ commit }, {_id, task_id, sub_id, value}) {
            try {
                await api.put(`/folders/${_id}/${task_id}/subs/${sub_id}`, { attr: 'completed', value })
                commit('SET_COMPLETED_SUB', {_id, task_id, sub_id, value})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить заметку в архив')
                throw e
            } 
        },          
        async setElderSub({ commit }, {_id, task_id, sub_id, value}) {
            try {
                await api.put(`/folders/${_id}/${task_id}/subs/${sub_id}`, { attr: 'elder', value })
                commit('SET_ELDER_SUB', {_id, task_id, sub_id, value})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Failed to elder sub')
                throw e
            } 
        },          
        async editSub({ commit }, {_id, task_id, sub_id, text}) {
            try {
                const req = await api.put(`/folders/${_id}/${task_id}/subs/${sub_id}`, { attr: 'body', value: text })
                commit('EDIT_SUB', {_id, task_id, sub_id, text})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось отредактировать заметку')
                throw e
            } 
        }, 
        async setImagesToSub({ commit }, {_id, task_id, sub_id, images}) {
            try {
                const req = await api.put(`/folders/${_id}/${task_id}/subs/${sub_id}`, { attr: 'images', valueJson: JSON.stringify(images) })
                commit('UPDATE_SUB', {_id, task_id, sub_id, attr: 'images', value: images})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить картинку для заметки')
                throw e
            } 
        },
        async setBlockedLinksToSub({ commit }, {_id, task_id, sub_id, blockedLinks}) {
            try {
                const req = await api.put(`/folders/${_id}/${task_id}/subs/${sub_id}`, { attr: 'blockedLinks', valueJson: JSON.stringify(blockedLinks) })
                commit('UPDATE_SUB', {_id, task_id, sub_id, attr: 'blockedLinks', value: blockedLinks})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить картинку для заметки в черный список')
                throw e
            } 
        }, 
        async moveSub({ commit }, {theme_from_id, task_from_id, task_to_id, sub_id, to_subs}) {
            try {
                const req = await api.put(`/folders/${theme_from_id}/${task_from_id}/subs/${sub_id}/move/${task_to_id}`, {})
                commit('MOVE_SUB', {theme_from_id, task_from_id, task_to_id, sub_id, to_subs: req.data.data}) 
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переместить заметку')
                throw e
            }
        },           
        async delSub({ commit }, {theme_id, task_id, sub_id}) {
            try {
                const req = await api.delete(`/folders/${theme_id}/${task_id}/subs/${sub_id}`)
                commit('UPD_TASK',{_id:theme_id, task_id, subs: req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить заметку')
                throw e
            }
        },
        async addRelatedTaskInTask({ commit }, {_id, task, related_task_id}) {
            try {
                const relatedTasksId = task.relatedTasks
                relatedTasksId.push(related_task_id)
                await api.put(`/folders/${_id}/tasks/${task._id}`, { attr: 'relatedTasks', valueJson: JSON.stringify(relatedTasksId) })
                commit('SET_RELATED_TASK_IN_TASK', {_id, task_id: task._id, relatedTasksId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить релевантный подраздел в подраздел')
                throw e
            } 
        }, 
        async deleteRelatedTaskInTask({ commit }, {_id, task, related_task_id}) {
            try {
                const relatedTasksId = task.relatedTasks
                relatedTasksId.splice(relatedTasksId.indexOf(related_task_id), 1)
                await api.put(`/folders/${_id}/tasks/${task._id}`, { attr: 'relatedTasks', valueJson: JSON.stringify(relatedTasksId) })
                commit('SET_RELATED_TASK_IN_TASK', {_id, task_id: task._id, relatedTasksId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить релевантный подраздел из подраздела')
                throw e
            } 
        },
        async addRelatedSubInTask({ commit }, {_id, task, related_sub_id}) {
            try {
                const relatedSubsId = task.relatedSubs
                relatedSubsId.push(related_sub_id)
                await api.put(`/folders/${_id}/tasks/${task._id}`, { attr: 'relatedSubs', valueJson: JSON.stringify(relatedSubsId) })
                commit('SET_RELATED_SUB_IN_TASK', {_id, task_id: task._id, relatedSubsId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить релевантную заметку в подраздел')
                throw e
            } 
        },
        async deleteRelatedSubInTask({ commit }, {_id, task, related_sub_id}) {
            try {
                const relatedSubsId = task.relatedSubs
                relatedSubsId.splice(relatedSubsId.indexOf(related_sub_id), 1)
                await api.put(`/folders/${_id}/tasks/${task._id}`, { attr: 'relatedSubs', valueJson: JSON.stringify(relatedSubsId) })
                commit('SET_RELATED_SUB_IN_TASK', {_id, task_id: task._id, relatedSubsId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить релевантную заметку из подраздела')
                throw e
            } 
        },
        async addRelatedTaskInSub({ commit }, {_id, task, sub, related_task_id}) {
            try {
                const relatedTasksId = sub.relatedTasks
                relatedTasksId.push(related_task_id)
                await api.put(`/folders/${_id}/${task._id}/subs/${sub._id}`, { attr: 'relatedTasks', valueJson: JSON.stringify(relatedTasksId) })
                commit('SET_RELATED_TASK_IN_SUB', {_id, task_id: task._id, sub_id: sub._id, relatedTasksId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить релевантный подраздел в заметку')
                throw e
            } 
        },
        async deleteRelatedTaskInSub({ commit }, {_id, task, sub, related_task_id}) {
            try {
                const relatedTasksId = sub.relatedTasks
                relatedTasksId.splice(relatedTasksId.indexOf(related_task_id), 1)
                await api.put(`/folders/${_id}/${task._id}/subs/${sub._id}`, { attr: 'relatedTasks', valueJson: JSON.stringify(relatedTasksId) })
                commit('SET_RELATED_TASK_IN_SUB', {_id, task_id: task._id, sub_id: sub._id, relatedTasksId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить релевантный подраздел из заметки')
                throw e
            } 
        },
        async addRelatedSubInSub({ commit }, {_id, task, sub, related_sub_id}) {
            try {
                const relatedSubsId = sub.relatedSubs
                relatedSubsId.push(related_sub_id)
                await api.put(`/folders/${_id}/${task._id}/subs/${sub._id}`, { attr: 'relatedSubs', valueJson: JSON.stringify(relatedSubsId) })
                commit('SET_RELATED_SUB_IN_SUB', {_id, task_id: task._id, sub_id: sub._id, relatedSubsId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить релевантную заметку в заметку')
                throw e
            } 
        },
        async deleteRelatedSubInSub({ commit }, {_id, task, sub, related_sub_id}) {
            try {
                const relatedSubsId = sub.relatedSubs
                relatedSubsId.splice(relatedSubsId.indexOf(related_sub_id), 1)
                await api.put(`/folders/${_id}/${task._id}/subs/${sub._id}`, { attr: 'relatedSubs', valueJson: JSON.stringify(relatedSubsId) })
                commit('SET_RELATED_SUB_IN_SUB', {_id, task_id: task._id, sub_id: sub._id, relatedSubsId})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить релевантную заметку из заметки')
                throw e
            } 
        },
        // async addAttachmentsInTask({ commit }, {_id, task_id, urls}) {
        //     try {
        //         await api.put(`/folders/${_id}/tasks/${task_id}`, { attr: 'attachments', valueJson: JSON.stringify({images: urls}) })
        //         commit('SET_ATTACHMENTS_IN_TASK', {_id, task_id, urls})
        //         return true
        //     }
        //     catch (e) {
        //         commit('SET_ERROR', 'Failed to add attachments in task')
        //         throw e
        //     } 
        // },
    }
}